import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionSetting, Resources, AppHttp } from '../../app.service';
import { NotificationService } from '../../shared/utils/notification.service';

declare var $: any;
declare var config: any;

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {

  private timeoutSecond = 0;
  private remainSecond = 0;
  private timer;

  validationOptions: any = {
    // Rules for form validation
    rules: {
      MAIL: { required: true, email: true, maxlength: 64 },
      USER_PASSWORD: { required: true, pwd: true, minlength: 8, maxlength: 32 },
      confirmPassword: { required: true, pwd: true, minlength: 8, maxlength: 32, equalTo: "#USER_PASSWORD" },
      verifyCode: { required: true }
    },
    submitHandler: () => this.changPassword()
  };

  constructor(private http: AppHttp, private router: Router, private notifyService: NotificationService) { }

  ngOnInit() { }

  /**
   * send code to mail
   */
  sendCode() {
    $("#mainForm").validate().resetForm();
    if (!$('#MAIL').valid()) {
      return;
    }
    $('#btnSendCode').prop('disabled', true);
    this.timeoutSecond = Math.round(new Date().getTime() / 1000) + 600;
    this.http.post('main', '/main/register/sendVerifyCode', { email: $('#MAIL').val(), check: 'canUpdate' }).then(r => {
      if (r.success) {
        this.setSeconds();
      } else {
        $('#btnSendCode').prop('disabled', false);
        if (r.message) {
          this.notifyService.smallBox({
            title: Resources.getLabel('password.changePassword'),
            content: r.message,
            color: '#C46A69',
            icon: 'fa fa-times shake animated'
          });
        }
      }
    })
  }

  /**
   * set remain time
   */
  setSeconds() {
    this.timer = setTimeout(() => {
      this.remainSecond = this.timeoutSecond - Math.round(new Date().getTime() / 1000);
      if (this.remainSecond > 0) {
        this.setSeconds();
      }
      else {
        this.remainSecond = 0;
        $('#btnSendCode').prop('disabled', false);
      }
    }, 1000);
  }

  /**
   * changPassword
   */
  changPassword() {
    $('#btnChangePassword').prop('disabled', true);
    let param = {};
    $('#mainForm').serializeArray().forEach(elem => {
      param[elem.name] = elem.value;
    });
    param['COMPANY_ID'] = 'DUMMY';
    this.http.put('main', '/main/forgot/password/' + $('[name=verifyCode]').val(), param).then(r => {
      $('#btnChangePassword').prop('disabled', false);
      if (r.success) {
        this.timeoutSecond = 0;
        if (r.message) {
          this.notifyService.smallBox({
            title: Resources.getLabel('password.changePassword'),
            content: r.message,
            color: '#8ac38b',
            icon: 'fa fa-check shake animated'
          });
        }
        this.router.navigate(['login']);
      } else {
        if (r.data && r.data[0]) {
          let validator = $('#mainForm').validate();
          validator.showErrors(r.data[0]);
          validator.focusInvalid();
        }
        if (r.message) {
          this.notifyService.smallBox({
            title: Resources.getLabel('password.changePassword'),
            content: r.message,
            color: '#C46A69',
            icon: 'fa fa-times shake animated'
          });
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/password/password.component.ts